import React from 'react';

const ToolButton = ({ active, icon: Icon, onClick, color, label, mini, danger, darkMode, disabled }) => (
    <button
        onClick={onClick}
        title={label}
        disabled={disabled}
        className={`
            relative rounded-2xl transition-all duration-300 ease-out
            flex flex-col items-center justify-center gap-1 w-full shrink-0
            backdrop-blur-sm border group
            ${mini ? 'p-2' : 'p-3'} 
            ${disabled ? 'opacity-40 cursor-not-allowed' : 'cursor-pointer'}
            ${active
                ? darkMode
                    ? 'bg-gradient-to-br from-violet-600 to-indigo-700 text-white shadow-lg shadow-violet-500/30 scale-105 border-violet-400/50'
                    : 'bg-gradient-to-br from-blue-500 to-indigo-600 text-white shadow-lg shadow-blue-500/30 scale-105 border-blue-400/50'
                : danger
                    ? darkMode
                        ? 'bg-red-900/30 text-red-400 border-red-500/30 hover:bg-red-800/50 hover:scale-102'
                        : 'bg-red-50 text-red-500 border-red-200 hover:bg-red-100 hover:scale-102'
                    : darkMode
                        ? 'bg-white/5 text-gray-400 border-white/10 hover:bg-white/10 hover:text-white hover:scale-102'
                        : 'bg-white/70 text-gray-500 border-gray-200/50 hover:bg-white hover:text-gray-700 hover:scale-102 hover:shadow-md'
            }
        `}
    >
        <Icon size={mini ? 18 : 22} color={color || 'currentColor'} strokeWidth={2} />
        <span className={`${mini ? 'text-[9px]' : 'text-[10px]'} font-semibold uppercase tracking-wide leading-tight truncate w-full px-0.5`}>
            {label}
        </span>
        {active && (
            <span className="absolute -top-1 -right-1 w-2.5 h-2.5 bg-green-400 rounded-full border-2 border-white shadow-sm animate-pulse" />
        )}
    </button>
);

export default ToolButton;
